import eqxApi from './eqxApi'

interface eqxEndpointConfig<TypeResponse, TypeInput> {
    success?: (api: eqxApi, response: any) => TypeResponse
    error?: (api: eqxApi, error: any, params?: FormData | TypeInput) => Promise<any> | undefined | null | void
    prepareData?: (api: eqxApi, data: any) => TypeInput | Promise<TypeInput>
}
export default class eqxEndpoint<TypeResponse, TypeInput = null> {
    url: string
    method: string
    config?: eqxEndpointConfig<TypeResponse, TypeInput>
    responseHandler?: (api: eqxApi, response: any) => TypeResponse
    errorHandler?: (api: eqxApi, error: any, params?: FormData | TypeInput) => any
    dataPreparer?: (api: eqxApi, data: any) => TypeInput | Promise<TypeInput>
    generatorParams: any

    constructor(
        url: string,
        method?: string,
        config?: eqxEndpointConfig<TypeResponse, TypeInput>,
        generatorParams: any = {}
    ) {
        this.url = url
        this.method = method ?? 'get'
        if (config) {
            this.responseHandler = config.success
            this.errorHandler = config.error
            this.dataPreparer = config.prepareData
        }
        this.generatorParams = generatorParams
    }
    prepareData(api: eqxApi, data: any): TypeInput | Promise<TypeInput> {
        return this.dataPreparer ? this.dataPreparer(api, data) : data
    }
    handleResponse(api: eqxApi, response: any): TypeResponse {
        return this.responseHandler ? this.responseHandler.apply(this, [api, response]) : (response as TypeResponse)
    }
    handleError(api: eqxApi, error: any, params?: TypeInput | FormData) {
        return this.errorHandler ? this.errorHandler.apply(this, [api, error, params]) : error
    }
    execute(api: eqxApi, data?: FormData | TypeInput, token?: string): Promise<TypeResponse> {
        let dataPromise = this.prepareData(api, data)
        if (!(dataPromise instanceof Promise)) {
            dataPromise = Promise.resolve(dataPromise)
        }
        return dataPromise.then((data: TypeInput) => {
            let promise: Promise<TypeResponse>
            const url = this.url
            if (this.method == 'post') {
                if (data instanceof FormData) {
                    promise = api.postFormData(url, data, {}, token)
                } else {
                    promise = api.post(url, data, {}, token)
                }
            } else {
                promise = api.get(url, data, {}, token)
            }
            const success = (response: any) => {
                response = this.handleResponse(api, response)
                return response as TypeResponse
            }
            return promise.then(success).catch((error) => {
                const promise = this.handleError(api, error, data)
                if (promise instanceof Promise) {
                    return promise.then(success)
                }
                throw error
            })
        })
    }
}
